import React from 'react';
import { Tooltip } from 'antd';

import { setDateFormat } from '../../../../lib/moment';
import { reDirectPage, setDetailPageUrl } from '../../../../lib/common';
import TableColumnTitle from '../../../../components/_table/TableColumnTitle';
import Anchor from '../../../../components/link/Anchor';
import { DATE_FORMAT } from '../../../../constants/service/common/utilConstants';
import {
  CATEGORY_EXHIBIT_TYPE,
  CATEGORY_EXHIBIT_TYPE_TEXT,
  CATEGORY_EXPOSE_LOCATION_TYPE,
  CATEGORY_EXPOSE_LOCATION_TYPE_TEXT,
  CATEGORY_SORT_TYPE,
  CATEGORY_SORT_TYPE_TEXT,
  CATEGORY_STATUS_TYPE,
  CATEGORY_STATUS_TYPE_TEXT,
  CATEGORY_TYPE,
  CATEGORY_TYPE_TEXT,
} from '../../../../constants/service/app/categoryConstants';
import { CATEGORY_DETAIL_URL_PATH } from '../../../../constants/service/common/urlConstants';

/**
 * 1차 카테고리 리스트 테이블 컬럼
 * @return {[{dataIndex: string, title: JSX.Element, render: (function(*))}, {dataIndex: string, title: JSX.Element, render: (function(*))}, {title: JSX.Element, render: (function())}, {dataIndex: string, title: JSX.Element, render: (function(*))}, {dataIndex: string, title: JSX.Element, render: (function(*))}, null, null, null, null, null, null, null]}
 */
export const columns = () => {
  return [
    {
      title: <TableColumnTitle title="카테고리 ID" />,
      dataIndex: 'id',
      render: (value) => (
        <Anchor
          text={value}
          isUnderLine
          color="primary"
          onClick={() => reDirectPage({ path: setDetailPageUrl(CATEGORY_DETAIL_URL_PATH, value) })}
        />
      ),
    },
    {
      title: <TableColumnTitle title="카테고리 종류" />,
      dataIndex: 'type',
      render: (value) => (
        <span>
          {value === CATEGORY_TYPE.GENERAL
            ? CATEGORY_TYPE_TEXT[CATEGORY_TYPE.GENERAL]
            : CATEGORY_TYPE_TEXT[CATEGORY_TYPE.EMPHASIS]}
        </span>
      ),
    },
    {
      title: <TableColumnTitle title="카테고리 구분" />,
      render: (value) => <span>{value.parentId ? 2 : 1}차 카테고리</span>,
    },
    {
      title: <TableColumnTitle title="카테고리 명" />,
      dataIndex: 'name',
      render: (value) => <span>{value}</span>,
    },
    {
      title: <TableColumnTitle title="하위 카테고리" />,
      dataIndex: 'subCategoryCount',
      render: (value) => <span>{value}</span>,
    },
    {
      title: <TableColumnTitle title="등록 상품 수" />,
      dataIndex: 'productCount',
      render: (value) => <span>{value}</span>,
    },
    {
      title: <TableColumnTitle title="활성 여부" />,
      dataIndex: 'status',
      render: (value) => (
        <span>
          {value === CATEGORY_STATUS_TYPE.INACTIVE
            ? CATEGORY_STATUS_TYPE_TEXT[CATEGORY_STATUS_TYPE.INACTIVE]
            : CATEGORY_STATUS_TYPE_TEXT[CATEGORY_STATUS_TYPE.ACTIVE]}
        </span>
      ),
    },
    {
      title: <TableColumnTitle title="전시 여부" />,
      dataIndex: 'isExhibit',
      render: (value) => (
        <span>
          {value === CATEGORY_EXHIBIT_TYPE.EXHIBIT
            ? CATEGORY_EXHIBIT_TYPE_TEXT[CATEGORY_EXHIBIT_TYPE.EXHIBIT]
            : CATEGORY_EXHIBIT_TYPE_TEXT[CATEGORY_EXHIBIT_TYPE.INEXHIBIT]}
        </span>
      ),
    },
    {
      title: (
        <div className="table-column-title-wrap">
          <TableColumnTitle title="노출위치" />
          <Tooltip
            title={
              <>
                <div>
                  • <strong>공통</strong>은 카테고리탭, 검색결과, 브랜드상세에서 노출됩니다.
                </div>
                <div>
                  • <strong>로컬</strong>은 카테고리탭에서만 노출됩니다.
                </div>
              </>
            }
            trigger="click"
          >
            <button className="category-exposure-type-caution-btn">!</button>
          </Tooltip>
        </div>
      ),
      dataIndex: 'exposureType',
      render: (value) => (
        <span>
          {value === CATEGORY_EXPOSE_LOCATION_TYPE.COMMON
            ? CATEGORY_EXPOSE_LOCATION_TYPE_TEXT[CATEGORY_EXPOSE_LOCATION_TYPE.COMMON]
            : CATEGORY_EXPOSE_LOCATION_TYPE_TEXT[CATEGORY_EXPOSE_LOCATION_TYPE.LOCAL]}
        </span>
      ),
    },
    {
      title: <TableColumnTitle title="상품정렬순" />,
      dataIndex: 'sortType',
      render: (value) => {
        let sortType;
        switch (value) {
          case CATEGORY_SORT_TYPE.TREND:
            sortType = CATEGORY_SORT_TYPE_TEXT[CATEGORY_SORT_TYPE.TREND];
            break;
          case CATEGORY_SORT_TYPE.POPULAR:
            sortType = CATEGORY_SORT_TYPE_TEXT[CATEGORY_SORT_TYPE.POPULAR];
            break;
          case CATEGORY_SORT_TYPE.NEW:
            sortType = CATEGORY_SORT_TYPE_TEXT[CATEGORY_SORT_TYPE.NEW];
            break;
          case CATEGORY_SORT_TYPE.MIN_PRICE:
            sortType = CATEGORY_SORT_TYPE_TEXT[CATEGORY_SORT_TYPE.MIN_PRICE];
            break;
          case CATEGORY_SORT_TYPE.MAX_PRICE:
            sortType = CATEGORY_SORT_TYPE_TEXT[CATEGORY_SORT_TYPE.MAX_PRICE];
            break;
          default:
            sortType = CATEGORY_SORT_TYPE_TEXT[CATEGORY_SORT_TYPE.TREND];
            break;
        }
        return <span>{sortType}</span>;
      },
    },
    {
      title: <TableColumnTitle title="생성일" />,
      dataIndex: 'createDate',
      render: (value) => <span>{setDateFormat(value, DATE_FORMAT.FULL_DASH_FORMAT)}</span>,
    },
    {
      title: <TableColumnTitle title="수정일" />,
      dataIndex: 'updateDate',
      render: (value) => <span>{setDateFormat(value, DATE_FORMAT.FULL_DASH_FORMAT)}</span>,
    },
  ];
};
